import { Search, XStack } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { SuppliersTableColumn } from '../../types/suppliersTableColumn'
import { SuppliersTableHideableColumnKey } from '../../types/suppliersTableHideableColumnKey'
import { SuppliersTableColumnSelectionMenu } from './elements/SuppliersTableColumnSelectionMenu'

interface SuppliersTableTitleProps {
  columns: SuppliersTableColumn[]
  hiddenColumnKeys: Set<SuppliersTableHideableColumnKey>
  onSearchChange: (searchValue: string) => void
  searchValue: string
  setHiddenColumnKeys: (hiddenColumnKeys: Set<SuppliersTableHideableColumnKey>) => void
}

export const SuppliersTableTitle = ({
  columns,
  hiddenColumnKeys,
  onSearchChange,
  searchValue,
  setHiddenColumnKeys,
}: SuppliersTableTitleProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <XStack align="center" gap={8}>
      <Search
        rounded
        noDropdown
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={t('suppliers.list.search.placeholder')}
        size="small"
        value={searchValue}
      />

      <SuppliersTableColumnSelectionMenu
        columns={columns}
        hiddenColumnKeys={hiddenColumnKeys}
        setHiddenColumnKeys={setHiddenColumnKeys}
      />
    </XStack>
  )
}
